import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Process {
  id: number;
  title: string;
  description: string;
  icon: string;
}

const ManufacturingExcellence = () => {
  const processes: Process[] = [
  {
    id: 1,
    title: 'Design Consultation',
    description: 'Collaborative design process understanding your brand identity and functional requirements.',
    icon: 'PencilSquareIcon'
  },
  {
    id: 2,
    title: 'Premium Materials',
    description: 'Sourcing the finest fabrics and materials that ensure durability and comfort.',
    icon: 'SwatchIcon'
  },
  {
    id: 3,
    title: 'Expert Craftsmanship',
    description: 'Skilled tailors with decades of experience creating each uniform with precision.',
    icon: 'WrenchScrewdriverIcon'
  },
  {
    id: 4,
    title: 'Quality Assurance',
    description: 'Rigorous multi-point inspection ensuring every piece meets our exacting standards.',
    icon: 'CheckBadgeIcon'
  }];


  return (
    <section className="py-20 bg-card">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-headline font-bold text-text-primary mb-6">
              Manufacturing Excellence
            </h2>
            <p className="text-lg font-body text-text-secondary mb-8 leading-relaxed">
              Our state-of-the-art facility in Dar es Salaam combines traditional tailoring expertise with modern production capabilities. Every uniform is a testament to Tanzanian craftsmanship and our commitment to quality.
            </p>

            <div className="space-y-6">
              {processes.map((process) =>
              <div
                key={process.id}
                className="flex items-start space-x-4 p-4 bg-muted rounded-lg hover:bg-accent hover:bg-opacity-10 transition-colors duration-300">

                  <div className="flex-shrink-0 w-12 h-12 bg-primary rounded-lg flex items-center justify-center">
                    <Icon
                    name={process.icon as any}
                    size={24}
                    variant="outline"
                    className="text-white" />

                  </div>
                  <div>
                    <h3 className="text-xl font-headline font-semibold text-text-primary mb-2">
                      {process.title}
                    </h3>
                    <p className="text-base font-body text-text-secondary">
                      {process.description}
                    </p>
                  </div>
                </div>
              )}
            </div>

            <div className="mt-8 grid grid-cols-3 gap-4">
              <div className="text-center p-4 bg-background rounded-lg">
                <p className="text-3xl font-headline font-bold text-primary mb-1">ISO</p>
                <p className="text-sm font-body text-text-secondary">Certified</p>
              </div>
              <div className="text-center p-4 bg-background rounded-lg">
                <p className="text-3xl font-headline font-bold text-primary mb-1">10+</p>
                <p className="text-sm font-body text-text-secondary">Years</p>
              </div>
              <div className="text-center p-4 bg-background rounded-lg">
                <p className="text-3xl font-headline font-bold text-primary mb-1">200+</p>
                <p className="text-sm font-body text-text-secondary">Staff</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative h-[600px] rounded-2xl overflow-hidden shadow-2xl">
              <AppImage
                src="/assets/images/manufacturing_excellence_corporate_uniforms.png"
                alt="Modern textile manufacturing facility with rows of industrial sewing machines and skilled workers creating corporate uniforms"
                className="w-full h-full object-cover" />

              <div className="absolute inset-0 bg-gradient-to-t from-primary via-transparent to-transparent opacity-40"></div>
            </div>

            <div className="absolute -bottom-6 -left-6 bg-brand-gold p-6 rounded-xl shadow-2xl max-w-xs">
              <div className="flex items-center space-x-4">
                <Icon name="ShieldCheckIcon" size={48} variant="solid" className="text-brand-gold-foreground" />
                <div>
                  <p className="text-lg font-headline font-bold text-brand-gold-foreground">
                    Quality Guaranteed
                  </p>
                  <p className="text-sm font-body text-brand-gold-foreground opacity-90">
                    Every uniform backed by our excellence promise
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default ManufacturingExcellence;